import { render, staticRenderFns } from "./VlModalComment.vue?vue&type=template&id=1013038d&scoped=true&"
import script from "./VlModalComment.vue?vue&type=script&lang=js&"
export * from "./VlModalComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013038d",
  null
  
)

export default component.exports